export var EAlert;
(function (EAlert) {
    EAlert["INCIDENT_CROWD"] = "INCIDENT_CROWD";
    EAlert["INCIDENT_STRAND"] = "INCIDENT_STRAND";
    EAlert["INCIDENT_INVADE"] = "INCIDENT_INVADE";
    EAlert["INCIDENT_RETROGRADE"] = "INCIDENT_RETROGRADE";
    EAlert["INCIDENT_CONGREGATE"] = "INCIDENT_CONGREGATE";
    EAlert["INCIDENT_SCATTER"] = "INCIDENT_SCATTER";
    EAlert["INCIDENT_SOCIAL_DISTANCE"] = "INCIDENT_SOCIAL_DISTANCE";
    EAlert["FACE_MATCH"] = "FACE_MATCH";
    EAlert["UMC_FACE_ANNOTATION"] = "UMC_FACE_ANNOTATION";
    EAlert["FACE_ANNOTATION"] = "FACE_ANNOTATION";
    EAlert["INCIDENT_VIRTUAL_REGION"] = "INCIDENT_VIRTUAL_REGION";
})(EAlert || (EAlert = {}));
export var TaskType;
(function (TaskType) {
    TaskType[TaskType["Face"] = 1] = "Face";
    TaskType[TaskType["Crowded"] = 4] = "Crowded";
    TaskType[TaskType["CrossLine"] = 5] = "CrossLine";
    TaskType[TaskType["DistanceTooClose"] = 7] = "DistanceTooClose";
    TaskType[TaskType["Gathering"] = 8] = "Gathering";
})(TaskType || (TaskType = {}));
